export default __webpack_public_path__ + "pgnv-assets/29e650be4c8045dd5f534262e4cf8f2c.png";